import { render } from "./Settings-setting--login-security.vue?vue&type=template&id=af909ce0"
import script from "./Settings-setting--login-security.vue?vue&type=script&lang=ts"
export * from "./Settings-setting--login-security.vue?vue&type=script&lang=ts"
script.render = render

export default script